var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "more_position" }, [
    _c(
      "div",
      { staticClass: "table_wrapper" },
      [
        _c(
          "div",
          { staticClass: "table_wrapper_search" },
          [
            _vm.enableGroupCorp && _vm.visibleOrgSelector
              ? _c("yxtbiz-group-org-select", {
                  staticClass: "mr12",
                  attrs: {
                    functionCode: _vm.functionCode,
                    dataPermissionCode: _vm.dataPermissionCode,
                    selectFirst: true,
                    disabled: _vm.disabled,
                    targetOrgId: _vm.targetOrgId,
                    setCurrentOrg: true,
                    clearable: false,
                    visibleOrgIds: _vm.visibleOrgIds,
                  },
                  on: { change: _vm.handleOrgChange },
                })
              : _vm._e(),
            _c(
              "select-popover",
              {
                ref: "selectPopover",
                attrs: { selectOpition: _vm.selectOpition },
              },
              [
                _c(
                  "div",
                  { staticClass: "table_tree" },
                  [
                    (_vm.enableGroupCorp && _vm.params.targetOrgId) ||
                    !_vm.enableGroupCorp
                      ? _c("yxtbiz-user-group-tree", {
                          ref: "deptTree",
                          attrs: {
                            targetOrgId: _vm.params.targetOrgId,
                            enableGroupCorp: _vm.enableGroupCorp,
                            placeholder: _vm.$t(
                              "biz_udp_usergroup_catalogname"
                            ),
                            filterable: "",
                            size: "large",
                            "default-expanded-keys": [""],
                            functionCode: _vm.functionCode,
                            dataPermissionCode: _vm.dataPermissionCode,
                          },
                          on: { nodeClick: _vm.nodeClick },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _c("yxt-input", {
              staticClass: "keyword ml12",
              staticStyle: { width: "240px" },
              attrs: {
                placeholder: _vm.$t("biz_udp_enter_usergroup"),
                searchable: "",
              },
              on: {
                search: function ($event) {
                  return _vm.getPositionData(true)
                },
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.getPositionData(true)
                },
              },
              model: {
                value: _vm.params.name,
                callback: function ($$v) {
                  _vm.$set(_vm.params, "name", $$v)
                },
                expression: "params.name",
              },
            }),
          ],
          1
        ),
        _c(
          "yxt-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "multipleTable",
            staticClass: "person-table",
            staticStyle: { width: "100%" },
            attrs: {
              height: _vm.tableHeight,
              "row-key": "id",
              data: _vm.tableData,
            },
            on: {
              select: _vm.handleSingleSeletct,
              "select-all": _vm.handleSelectAll,
            },
          },
          [
            _c("yxt-table-column", {
              attrs: {
                type: "selection",
                "class-name": "table-selection-odd",
                width: "40",
                "show-overflow-tooltip": false,
              },
            }),
            _c("yxt-table-column", {
              attrs: {
                prop: "name",
                "show-overflow-tooltip": "",
                label: _vm.$t("biz_udp_usergroup"),
                "min-width": "180",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.name))]),
                      scope.row.userGroupType === 1
                        ? _c(
                            "yxt-tag",
                            {
                              staticClass: "ml8",
                              attrs: { effect: "dark", size: "mini" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("pc_biz_ls_group").d("集团")) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("yxt-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "remark",
                label: _vm.$t("pc_biz_udp_lbl_description"),
                "min-width": "180",
              },
            }),
            _c("template", { slot: "empty" }, [
              _c(
                "div",
                { staticStyle: { "line-height": "normal" } },
                [_c("yxt-empty")],
                1
              ),
            ]),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "yxtbiz-page__content" },
          [
            _c(
              "div",
              { staticClass: "yxtbiz-page__content-right" },
              [
                _c(
                  "yxt-button",
                  {
                    staticClass: "lh32",
                    class: _vm.loadingAll ? "color-primary-4 disabled" : "",
                    attrs: { type: "text", disabled: !_vm.tableData.length },
                    on: { click: _vm.loadAll },
                  },
                  [_vm._v(_vm._s(_vm.$t("biz_udp_all_filter_results")))]
                ),
                _c("div", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingAll,
                      expression: "loadingAll",
                    },
                  ],
                  staticClass: "yxtbiz-loading__all",
                }),
              ],
              1
            ),
            _c("yxt-pagination", {
              staticClass: "pages",
              attrs: {
                small: "",
                "page-size": _vm.params.limit,
                "page-sizes": [5, 10, 20, 30, 50, 100],
                "current-page": _vm.currentPage,
                layout: "total, prev, pager, next",
                total: _vm.total,
                "simple-total": "",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "update:currentPage": function ($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function ($event) {
                  _vm.currentPage = $event
                },
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }